import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import { UploadOutlined, UserOutlined, MailOutlined, PhoneOutlined, IdcardOutlined, BankOutlined, EnvironmentOutlined } from "@ant-design/icons";

import {
  getaUser,
  getUsers,
  createUser,
  updateUser,
  resetState,
} from "../features/cutomers/customerSlice";
import { getStates } from "../features/statecity/statecitySlice";
import { getClusters } from "../features/cluster/clusterSlice";
import { getSchools } from "../features/schools/schoolSlice";
import { getJobtrades, getSectors } from "../features/brand/brandSlice";
import { Button, Form, Input, Select, Divider, Radio, Row, Col, Card, Spin, Space, Tag } from "antd";

const { Option } = Select;
const { TextArea } = Input;

const Addvtvc = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [districtOptions, setDistrictOptions] = useState([]);
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [tradeOptions, setTradeOptions] = useState([]);
  const [jobroleOptions, setjobroleOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState("vc");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const statelistState = useSelector((state) => state.statecity.statelist || []);
  const clusterlistState = useSelector((state) => state.cluster.cluster || []);
  const vclistState = useSelector((state) => state.customer.customers || []);
  const userState = useSelector((state) => state.customer);
  const schoolState = useSelector((state) => state.school.schools || []);

  useEffect(() => {
    dispatch(getStates());
    dispatch(getClusters());
    dispatch(getUsers());
    dispatch(getSchools());
    dispatch(getJobtrades());
    dispatch(getSectors());

    if (id) {
      dispatch(getaUser(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (selectedState) {
      fetchDistricts(selectedState);
    }
  }, [selectedState, statelistState]);

  useEffect(() => {
    if (selectedDistrict) {
      fetchSchools(selectedDistrict);
    }
  }, [selectedDistrict, schoolState]);

  useEffect(() => {
    if (id && userState.customers && userState.customers.length > 0) {
      const user = userState.customers.find((u) => u._id === id);
      if (user) {
        setSelectedState(user.state);
        setSelectedDistrict(user.district);
        setSelectedRole(user.role || "vc");
        
        let jobRoleValue = user.job_role;
        if (typeof jobRoleValue === "string" && jobRoleValue.includes(",")) {
          jobRoleValue = jobRoleValue.split(",").map((s) => s.trim());
        } else if (jobRoleValue && !Array.isArray(jobRoleValue)) {
          jobRoleValue = [jobRoleValue];
        }

        form.setFieldsValue({
          ...user,
          job_role: jobRoleValue,
          school_name: user.schoolId ? `${user.schoolId}|${user.school_name}` : user.school_name,
        });
      }
    }
  }, [id, userState.customers, form]);

  const handleStateChange = (value) => {
    setSelectedState(value);
    setSelectedDistrict("");
    form.setFieldsValue({ district: undefined, school_name: undefined });
    setDistrictOptions([]);
    setSchoolOptions([]);
    setTradeOptions([]);
    setjobroleOptions([]);
  };

  const fetchDistricts = (stateCode) => {
    const foundState = statelistState.find((s) => s.code === stateCode || s.state_name === stateCode);
    if (foundState && foundState.district_name) {
      setDistrictOptions(foundState.district_name);
    } else {
      setDistrictOptions([]);
    }
  };

  const handleDistrictChange = (value) => {
    setSelectedDistrict(value);
    form.setFieldsValue({ school_name: undefined });
    setTradeOptions([]);
    setjobroleOptions([]);
  };

  const fetchSchools = (district) => {
    const filtered = schoolState.filter((s) => s.district === district);
    setSchoolOptions(filtered);
  };

  const handleSchoolChange = (values) => {
    if (!values) return;
    const [schoolId] = values.split("|");
    const matchedSchool = schoolState.find((s) => s.UDISE_Code === schoolId);
    if (matchedSchool) {
      setTradeOptions(matchedSchool.trades || []);
      setjobroleOptions(matchedSchool.jobroles || []);
    }
  };

  const handleRoleChange = (e) => {
    setSelectedRole(e.target.value);
  };

  const onFinish = (values) => {
    setLoading(true);
    let modifiedValues = { ...values };

    if (values.school_name && values.school_name.includes("|")) {
      const [schoolId, school_name] = values.school_name.split("|");
      modifiedValues.schoolId = schoolId;
      modifiedValues.school_name = school_name;
    }

    if (id) {
      dispatch(updateUser({ id, ...modifiedValues }));
    } else {
      dispatch(createUser(modifiedValues));
    }

    setTimeout(() => {
      dispatch(resetState());
      setLoading(false);
    }, 500);
  };

  const { isSuccess, isError, errorMessage, createdcustomers, updatedcustomers } = userState;

  useEffect(() => {
    if ((isSuccess && createdcustomers) || (isSuccess && updatedcustomers)) {
      toast.success(id ? "User details updated successfully!" : "VT/VC registered successfully!");
      navigate("/admin/customers");
    }

    if (isError) {
      toast.error(errorMessage || "Something went wrong! Please check form inputs.");
    }
  }, [isSuccess, isError, errorMessage, navigate, createdcustomers, updatedcustomers, id]);

  const prefixSelector = (
    <Form.Item name="prefix" noStyle initialValue="+91">
      <Select style={{ width: 75 }} defaultValue="+91">
        <Option value="+91">+91</Option>
      </Select>
    </Form.Item>
  );

  return (
    <div style={{ padding: "20px 24px", minHeight: "100vh", backgroundColor: "#f8fafc" }}>
      {/* Top Header & Breadcrumb Bar */}
      <div
        style={{
          maxWidth: "1050px",
          margin: "0 auto 16px auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Button
            onClick={() => navigate(-1)}
            icon={<BiArrowBack />}
            style={{
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
            }}
          >
            Back
          </Button>
          <div>
            <h2 style={{ margin: 0, fontSize: "22px", fontWeight: 700, color: "#0f172a" }}>
              {id ? "Edit VT/VC Profile" : "Register VT / VC"}
            </h2>
            <span style={{ fontSize: "13px", color: "#64748b" }}>
              {id ? "Update existing co-ordinator or trainer details" : "Add a new Vocational Co-ordinator or Trainer"}
            </span>
          </div>
        </div>

        <Link to="/admin/add-bulkvt">
          <Button
            type="primary"
            icon={<UploadOutlined />}
            style={{
              borderRadius: "8px",
              backgroundColor: "#2563eb",
              borderColor: "#2563eb",
              fontWeight: 500,
            }}
          >
            Upload Bulk VT
          </Button>
        </Link>
      </div>

      {/* Main Registration Card Form */}
      <Card
        style={{
          maxWidth: "1050px",
          margin: "0 auto",
          borderRadius: "14px",
          boxShadow: "0 4px 16px rgba(15, 23, 42, 0.06)",
          border: "1px solid #e2e8f0",
        }}
        bodyStyle={{ padding: "28px 32px" }}
      >
        <Form
          form={form}
          name="register"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ prefix: "+91", role: "vc" }}
          scrollToFirstError
        >
          {/* Section 0: Role Selection */}
          <div
            style={{
              background: "#f1f5f9",
              padding: "16px 20px",
              borderRadius: "10px",
              marginBottom: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <div>
              <div style={{ fontWeight: 600, fontSize: "15px", color: "#0f172a" }}>Select Account Role</div>
              <div style={{ fontSize: "12px", color: "#64748b" }}>
                Choose whether you are creating a Vocational Co-ordinator or a Vocational Trainer
              </div>
            </div>

            <Form.Item name="role" style={{ margin: 0 }} rules={[{ required: true, message: "Please select a Role!" }]}>
              <Radio.Group
                value={selectedRole}
                onChange={handleRoleChange}
                buttonStyle="solid"
                size="large"
              >
                <Radio.Button value="vc" style={{ fontWeight: 600, borderRadius: "6px 0 0 6px" }}>
                  VC (Vocational Co-ordinator)
                </Radio.Button>
                <Radio.Button value="vt" style={{ fontWeight: 600, borderRadius: "0 6px 6px 0" }}>
                  VT (Vocational Trainer)
                </Radio.Button>
              </Radio.Group>
            </Form.Item>
          </div>

          {/* Section 1: Personal & Basic Details */}
          <div style={{ marginBottom: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
              <UserOutlined style={{ color: "#2563eb", fontSize: "16px" }} />
              <h4 style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "#1e293b" }}>
                1. Personal & Contact Information
              </h4>
            </div>

            <Row gutter={20}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="name"
                  label={<span style={{ fontWeight: 500 }}>Full Name</span>}
                  rules={[{ required: true, message: "Please enter candidate's full name!", whitespace: true }]}
                >
                  <Input
                    placeholder="e.g. Bikash Chandra Biswal"
                    prefix={<UserOutlined style={{ color: "#94a3b8" }} />}
                    size="large"
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="unique_id"
                  label={<span style={{ fontWeight: 500 }}>Unique ID / Employee ID</span>}
                  rules={[{ required: true, message: "Please enter unique ID!", whitespace: true }]}
                >
                  <Input
                    placeholder="e.g. LNJS2760 or Mobile No"
                    prefix={<IdcardOutlined style={{ color: "#94a3b8" }} />}
                    size="large"
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="email"
                  label={<span style={{ fontWeight: 500 }}>Email Address</span>}
                  rules={[
                    { required: true, message: "Please enter email address!" },
                    { type: "email", message: "Please enter a valid email address!" },
                  ]}
                >
                  <Input
                    placeholder="e.g. name@lnjskills.com"
                    prefix={<MailOutlined style={{ color: "#94a3b8" }} />}
                    size="large"
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="phone_no"
                  label={<span style={{ fontWeight: 500 }}>Mobile Number</span>}
                  rules={[
                    { required: true, message: "Please enter phone number!" },
                    { pattern: /^[0-9]{10}$/, message: "Please enter a valid 10-digit mobile number!" },
                  ]}
                >
                  <Input
                    addonBefore={prefixSelector}
                    placeholder="9040384458"
                    size="large"
                    style={{ width: "100%", borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="qualification"
                  label={<span style={{ fontWeight: 500 }}>Qualification</span>}
                  rules={[{ required: true, message: "Please enter qualification!" }]}
                >
                  <Input
                    placeholder="e.g. Graduate, B.Tech, M.A."
                    size="large"
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="experience"
                  label={<span style={{ fontWeight: 500 }}>Experience (in Years)</span>}
                  rules={[{ required: true, message: "Please enter experience!" }]}
                >
                  <Input
                    placeholder="e.g. 2 Years"
                    size="large"
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <Divider style={{ margin: "16px 0 24px 0" }} />

          {/* Section 2: Location Information */}
          <div style={{ marginBottom: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
              <EnvironmentOutlined style={{ color: "#16a34a", fontSize: "16px" }} />
              <h4 style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "#1e293b" }}>
                2. Location & State Assignment
              </h4>
            </div>

            <Row gutter={20}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="state"
                  label={<span style={{ fontWeight: 500 }}>State</span>}
                  rules={[{ required: true, message: "Please select State!" }]}
                >
                  <Select
                    placeholder="Select State"
                    onChange={handleStateChange}
                    size="large"
                    showSearch
                    filterOption={(input, option) =>
                      (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ borderRadius: "8px" }}
                  >
                    {statelistState.map((s) => (
                      <Option key={s.code} value={s.code}>
                        {s.state_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="district"
                  label={<span style={{ fontWeight: 500 }}>District</span>}
                  rules={[{ required: true, message: "Please select District!" }]}
                >
                  <Select
                    placeholder="Select District"
                    disabled={!selectedState}
                    onChange={handleDistrictChange}
                    size="large"
                    showSearch
                    filterOption={(input, option) =>
                      (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ borderRadius: "8px" }}
                  >
                    {districtOptions.map((district, index) => (
                      <Option key={index} value={district}>
                        {district}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24}>
                <Form.Item
                  name="address"
                  label={<span style={{ fontWeight: 500 }}>Full Residential / Official Address</span>}
                  rules={[{ required: true, message: "Please enter address!" }]}
                >
                  <TextArea
                    rows={2}
                    placeholder="Enter complete street address, landmark, PIN code"
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <Divider style={{ margin: "16px 0 24px 0" }} />

          {/* Section 3: Role Specific Assignment */}
          <div style={{ marginBottom: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
              <BankOutlined style={{ color: "#8b5cf6", fontSize: "16px" }} />
              <h4 style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "#1e293b" }}>
                3. Role Assignments ({selectedRole === "vc" ? "Vocational Co-ordinator" : "Vocational Trainer"})
              </h4>
            </div>

            <Row gutter={20}>
              {selectedRole === "vc" && (
                <Col xs={24} sm={12}>
                  <Form.Item name="cluster_name" label={<span style={{ fontWeight: 500 }}>Select Cluster</span>}>
                    <Select placeholder="Select Assigned Cluster" size="large" allowClear style={{ borderRadius: "8px" }}>
                      {clusterlistState.map((c) => (
                        <Option key={c._id} value={c._id}>
                          {c.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}

              {selectedRole === "vt" && (
                <>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="vcuser_id"
                      label={<span style={{ fontWeight: 500 }}>Assigned Vocational Co-ordinator (VC)</span>}
                      rules={[{ required: true, message: "Please assign a VC to this Trainer!" }]}
                    >
                      <Select
                        placeholder="Select Reporting VC"
                        size="large"
                        showSearch
                        filterOption={(input, option) =>
                          (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                        style={{ borderRadius: "8px" }}
                      >
                        {vclistState
                          .filter((item) => item.role === "vc")
                          .map((item) => (
                            <Option key={item._id} value={item._id}>
                              {item.name} ({item.unique_id || item.phone_no})
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="school_name"
                      label={<span style={{ fontWeight: 500 }}>Assigned School</span>}
                      rules={[{ required: true, message: "Please select School!" }]}
                    >
                      <Select
                        placeholder={selectedDistrict ? "Select School in District" : "Select District first"}
                        onChange={handleSchoolChange}
                        disabled={!selectedDistrict}
                        size="large"
                        showSearch
                        filterOption={(input, option) =>
                          (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                        style={{ borderRadius: "8px" }}
                      >
                        {schoolOptions.map((s) => (
                          <Option key={s._id} value={`${s.UDISE_Code}|${s.school_name}`}>
                            {s.school_name} (UDISE: {s.UDISE_Code})
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="skill_area"
                      label={<span style={{ fontWeight: 500 }}>Select Trade</span>}
                      rules={[{ required: true, message: "Please select Trade!" }]}
                    >
                      <Select placeholder="Select Trade" size="large" style={{ borderRadius: "8px" }}>
                        {tradeOptions.map((trade, idx) => (
                          <Option key={idx} value={trade}>
                            {trade}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="job_role"
                      label={<span style={{ fontWeight: 500 }}>Select Job Role(s)</span>}
                      rules={[{ required: true, message: "Please select at least one Job Role!" }]}
                    >
                      <Select
                        mode="multiple"
                        placeholder="Select Job Roles"
                        size="large"
                        style={{ borderRadius: "8px" }}
                      >
                        {jobroleOptions.map((job, idx) => (
                          <Option key={idx} value={job}>
                            {job}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>
          </div>

          <Divider style={{ margin: "24px 0" }} />

          {/* Submit Action */}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
            <Button size="large" onClick={() => navigate(-1)} style={{ borderRadius: "8px", minWidth: "110px" }}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              style={{
                borderRadius: "8px",
                backgroundColor: "#16a34a",
                borderColor: "#16a34a",
                fontWeight: 600,
                minWidth: "160px",
                boxShadow: "0 2px 6px rgba(22, 163, 74, 0.25)",
              }}
            >
              {id ? "Update VT/VC" : "Register VT/VC"}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Addvtvc;